// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/index.css
// module id = 1AEq
// module chunks = 2